import { jsx as _jsx } from "react/jsx-runtime";
import { TextField } from "@mui/material";
import { IMaskMixin } from "react-imask";
const NerdMaskField = IMaskMixin(({ inputRef, textFieldProps }) => (_jsx(TextField, { inputRef: inputRef, ...textFieldProps })));
export default NerdMaskField;
